import React from 'react';

const About = () => {
    return (  
        <div className='about' id='About'>
            <div className='about-info'>
                <h2>Sobre mi</h2>
                <div className='divider const'></div>
                <p>
                    Mi nombre es Bastian Valdivia, egresado 
                    ingenieria en informatica.
                    Durante mis años de estudio pude obtener 
                    conocimientos de diferentes areas de esta carrea 
                    tales como redes, base de datos, y desarrollo web. 
                    Es en esta ultima area en la que quise enfocar mi 
                    tiempode estudio para convertirme en desarrollador 
                    web FullStack
                </p>
                <p>
                    Soy una persona autodidacta, con mucho deseo por 
                    aprender, adquirir nuevos conocimientos y volverme 
                    un mejor profesinal, por esto, para el desarrollo 
                    frontend aprendi a trabajar con el lenguaje de 
                    JavaScript y la libreria de React, principalmente 
                    con Redux, ademas de CSS y HTML. En cuanto al 
                    desarrollo del backend principalmente utilizo NodeJs 
                    y MongoBD. 
                </p>
            </div>
        </div>
    );
}
 
export default About;